<template>
  <v-layout
  
    v-if="!$apollo.loading && !_.isEmpty(botManagers)"
    justify-center
    wrap
  >
    <v-flex
      md12  
    >
      <v-card>
        <v-data-table
          :headers="headers"
          :items="botManagers"
          :hide-default-footer="true"
          :mobile-breakpoint="900"
          :items-per-page="200"
        >
          <template
            slot="headerCell"
            slot-scope="{ header }"
          >
            <span
              v-text="header.text"
            />
          </template>
          <template v-slot:item.logo="{ item }">
            <v-avatar
              :tile="false"
              :size="40"
            >
              <v-img
                :src="(item.logo || require('@/images/no-image.png'))"
                :lazy-src="item.logo"
                max-height="40"
                contain
              />
            </v-avatar>  
          </template>
          <template v-slot:item.name="{ item }">
            <b>{{ item.name }}</b><br>
            <small>{{ item.entity_name }}</small>
          </template>
          <template v-slot:item.max_bots="{ item }">
            <b>{{ item.max_bots }}</b>
          </template>
          <template v-slot:item.aum_bots="{ item }">
            <b>{{ item.aum_bots }}</b>
          </template>
          <template v-slot:item.description="{ item }">
            <template>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                {{ JSON.parse(item.description)[$i18n.locale] }}
              </v-tooltip>
            </template>
          </template>    
          <template v-slot:item.actions="{ item }">
            <v-btn
              outlined
              text
              small
              @click="connectBot(item.id)"
            >
              {{ $t('bots.linkButton') }}
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
    <connect-bot-dialog :show-dialog="connectDialog" />
  </v-layout>
  <v-layout
    v-else
    v-show="!$apollo.loading"
    wrap
    justify-center
  >
    <v-flex
      md5
      xs12
      new-record
      mt-5
    >
      <v-card
        style="padding:50px"
      >
        <component :is="newIcon" />
        <h3>{{ $t('bots.managerNotFound') }}</h3>
        <p>
          {{ $t('bots.managerNotFoundDesc') }}
        </p>  
      </v-card>  
    </v-flex>
  </v-layout>
</template>

<script>

const BOT_MANAGERS_QUERY = require('@/graphql/queries/BotManagers.gql');
import IconBotManager from '@/components/icons/IconBotManager.vue'
import ConnectBotDialog from '@/views/TraderBots/partial/ConnectBotDialog.vue'

export default {
  name: 'UserBots',
  components: {
    ConnectBotDialog
  },
  data() {
    return {
      connectDialog: false,
      selectedManager: null,
      loading: false,
      newIcon: IconBotManager,
      headers: [
        {
          sortable: false,
          text: '',
          value: 'logo'
        },
        {
          sortable: false,
          text: this.$t('bots.managerName'),
          value: 'name'
        },
        {
          sortable: false,
          text: this.$t('globals.description'),
          value: 'description'
        },
        {
          sortable: false,
          text: this.$t('bots.maxBots'),
          value: 'max_bots',
        },
        {
          sortable: false,
          text: this.$t('bots.linkedBots'),
          value: 'aum_bots',
        },
        {
          sortable: false,
          text: '',
          value: 'actions',
        },
      ]
    } 
  },
  methods: {
    connectBot(id) {
      this.selectedManager = id
      this.connectDialog = true
    }
  },
  apollo: {
    botManagers: {
      query: BOT_MANAGERS_QUERY,
    }
  },
}
</script>
<style lang="scss" scoped>
  h2 {
    display: inline-block;
  }
  .btn-project {
    float: right;
    margin: 20px 0 10px;
  }
  .ticker {
    font-weight: 700;
    color: #9c27b0;
  }
  .name {
    font-weight: 600;
    color: #7f97ab;
  }
  .v-avatar {
    margin: 10px 0;
  }
</style>
